import { ActionTree, MutationTree, GetterTree } from 'vuex/types/index';
import type { DebitOrderMandate, DebitOrderMandatePayload } from './types';

export const state = () => {
  return {
    debitOrderMandate: {} as DebitOrderMandate,
  };
};

export const getters: GetterTree<any, any> = {
  getDebitOrderMandate(state) {
    const debitOrderMandate = state.debitOrderMandate;
    return debitOrderMandate;
  },
};

export const mutations: MutationTree<any> = {
  setDebitOrderMandate(state, debitOrderMandate: any) {
    state.debitOrderMandate = debitOrderMandate;
  },
};

export const actions: ActionTree<any, any> = {
  async initiateDebitOrder({ dispatch }, payload: DebitOrderMandatePayload) {
    await this.$axios.$post('/debit-order-mandates', payload);
    await dispatch('getDebitOrderMandate', payload.merchantId);
  },
  async getDebitOrderMandate({ commit }, merchantId: string) {
    try {
      const response = await this.$axios.$get(`/merchants/${merchantId}/debit-order-mandates`);
      commit('setDebitOrderMandate', response);
      return response as DebitOrderMandate;
    } catch (error: any) {
      if (error.status === 404) return {} as DebitOrderMandate;
    }
  },
};
